// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './routers'
import 'babel-polyfill'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/public.css'
import element from '../theme/theme'
import store from './store/store'
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false

import { PageHeader } from 'element-ui';
Vue.use(PageHeader);
import { Switch } from 'element-ui';
Vue.use(Switch);
import { Loading } from 'element-ui';
Vue.use(Loading.directive);
import { Popover } from 'element-ui';
Vue.use(Popover);
import { Cascader } from 'element-ui';
Vue.use(Cascader);
import { CascaderPanel } from 'element-ui';
Vue.use(CascaderPanel);
import { MessageBox } from 'element-ui';
Vue.prototype.$confirm = MessageBox.confirm;
// import supportIE from "./utils/placeholder"; //IE placeholder兼容指令
// Vue.use(supportIE);

//sessionStorage监听
Vue.prototype.resetSetItem = function (key, newVal) {
  if (key === 'account') {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent('StorageEvent');
    const storage = {
      setItem: function (k, val) {
        sessionStorage.setItem(k, val);

        // 初始化创建的事件
        newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);

        // 派发对象
        window.dispatchEvent(newStorageEvent)
      }
    }
    return storage.setItem(key, newVal);
  }
}

Vue.use(element)
/* eslint-disable no-new */
//ajax
import { ajax } from './assets/js/ajax'
Vue.prototype.$ajax = ajax;
// 高德地图
import '../map';
const amapKeys = Object.keys(localStorage).filter(key => key.match(/^_AMap_/))

amapKeys.forEach(key => {
  // console.log(key)
  localStorage.removeItem(key)
})
// import VueAMap from '../map';
// Vue.use(VueAMap)

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js